import { memo } from 'react';
import { useState, useCallback, useEffect } from 'react';
import { SelectField, TextField, MultilineField, Autocomplete } from 'style-guide';
import { TableCell, TableHead, TableRow, Typography, FormControlLabel, Checkbox, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const UserHeader = props => {
    const { roles, customers } = useSelector(state => state.users);
    const { consigneeNameOptions } = useSelector(state => state.consignees);
    const [locations, setLocations] = useState([{ "id": 1, "code": "NL", "name": "Nederland" }, { "id": 2, "code": "IL", "name": "Israel" }, { "id": 4, "code": "US", "name": "US" }]);
    const [name, setName] = useState("");
    const [un, setUN] = useState("");
    const [loc, setLoc] = useState(null);
    const [conId, setConId] = useState(null);
    const [role, setRole] = useState(null);
    const [active, setActive] = useState(true);

    const customerNameOptions = consigneeNameOptions.map(consigneeNameOption => ({
        id: consigneeNameOption.id,
        name: consigneeNameOption.name,
    }));

    const onConsigneeChange = (field, value) => {
        setConId(value);
    }
    return (
        <TableHead>
            <TableRow>
                <TableCell />
                <TableCell>
                    <TextField
                        required
                        lg={11}
                        value={name}
                        onChange={event => {
                            setName(event.target.value);
                        }}
                        label='Name'
                    />
                </TableCell>
                <TableCell>
                    <Autocomplete
                        field='consigneeId'
                        label='Consignee'
                        lg={12}
                        value={conId}
                        onChange={onConsigneeChange}
                        options={consigneeNameOptions}
                    />
                    {/*<TextField
                        required
                        lg={11}
                        value={un}
                        onChange={event => {
                            setUN(event.target.value);
                        }}
                        label='User Name'
                    />*/}
                </TableCell>
                <TableCell>
                    {/*<SelectField
                        required
                        lg={11}
                        label='Location'
                        value={location}
                        options={locations}
                        onChange={event => {
                            setLocation(event.target.value)
                        }} />*/}
                    <Typography variant='h6' style={{ textAlign: "left" }}>Location</Typography>
                </TableCell>
                <TableCell>
                    <Typography variant='h6' style={{ textAlign: "left" }}>Notes</Typography>
                </TableCell>
                <TableCell>
                    {/*<SelectField
                        required
                        value={role}
                        lg={5.5}
                        onChange={event => {
                            setRole(event.target.value);
                        }}
                        label='Role'
                        options={roles}
                    />*/}
                    <Typography variant='h6' style={{ textAlign: "left" }}>Role</Typography>
                </TableCell>
                <TableCell>
                    <FormControlLabel
                        control={
                            <Checkbox checked={(active != null) ? active : true} onChange={event => {
                                setActive(event.target.checked)
                            }} />
                        }
                        label={active ? "Status" : "Status"}
                    />
                </TableCell>
                <TableCell>
                    <Button variant='contained' onClick={() => { props.setFilter(name, un, loc, role, active, conId) }}>Search</Button>
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default memo(UserHeader);
